<template>
  <router-view />
</template>

<route>
{
  "redirect": "/customer/reporting/summary",
  "name": "customer settings",
  "meta": {
    "authorize" : [1, 3, 4]
  }
}
</route>

<script>
export default {
  layout: "customer",
};
</script>
